<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "Dispute-Raised",
        "hide-footer": "",
        centered: "",
        size: "md-100",
      },
      on: {
        hide: function ($event) {
          return _vm.onModalHidden(false)
        },
      },
      model: {
        value: _vm.modalVisible,
        callback: function ($$v) {
          _vm.modalVisible = $$v
        },
        expression: "modalVisible",
      },
    },
    [
      _c("h4", { staticClass: "mb-1 text-center head-top-25" }, [
        _vm._v(" " + _vm._s(_vm.$t("dispute.SubmitDispute")) + " "),
      ]),
      _c("validation-observer", {
        ref: "disputeForm",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              return [
                _c(
                  "b-form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.validationForm($event)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "disput-pop" },
                      [
                        _c("Stepper", {
                          key: _vm.updateState,
                          attrs: { steps: _vm.steps },
                        }),
                        _c(
                          "b-alert",
                          {
                            staticClass: "d-flex alert-padding",
                            attrs: { variant: "primary", show: "" },
                          },
                          [
                            _c("ol", { staticClass: "ol-text mt-1" }, [
                              _c("li", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("Dispute-Status-pop.data-1")
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("Dispute-Status-pop.data-2")
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("Dispute-Status-pop.data-3")
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "mt-1 mb-2" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "bv-no-focus-ring col-form-label pt-0",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Dispute-Status-pop.Reason")
                                      ) + " "
                                    ),
                                    _c("span", { staticClass: "red-star" }, [
                                      _vm._v("*"),
                                    ]),
                                  ]
                                ),
                                _c("validation-provider", {
                                  attrs: {
                                    name: _vm.$t("Dispute-Status-pop.Reason"),
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("v-select", {
                                              attrs: {
                                                options: _vm.options,
                                                label: "value",
                                                reduce: function (option) {
                                                  return option.value
                                                },
                                              },
                                              model: {
                                                value: _vm.reason,
                                                callback: function ($$v) {
                                                  _vm.reason = $$v
                                                },
                                                expression: "reason",
                                              },
                                            }),
                                            _c("Errors", {
                                              attrs: { error: errors[0] },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "mt-1 mb-2" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "bv-no-focus-ring col-form-label pt-0",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Dispute-Status-pop.Description")
                                      ) + " "
                                    ),
                                    _c("span", { staticClass: "red-star" }, [
                                      _vm._v("*"),
                                    ]),
                                  ]
                                ),
                                _c("validation-provider", {
                                  attrs: {
                                    name: _vm.$t(
                                      "Dispute-Status-pop.Description"
                                    ),
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-textarea", {
                                              staticClass: "no-border",
                                              attrs: {
                                                "no-resize": "",
                                                rows: "3",
                                                placeholder: _vm.$t(
                                                  "Dispute-Status-pop.Description"
                                                ),
                                              },
                                              model: {
                                                value: _vm.message,
                                                callback: function ($$v) {
                                                  _vm.message = $$v
                                                },
                                                expression: "message",
                                              },
                                            }),
                                            _c("Errors", {
                                              attrs: { error: errors[0] },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "mt-1 mb-2" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "bv-no-focus-ring col-form-label pt-0",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Dispute-Status-pop.Upload-proof"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-uplooad pay-upload p-none",
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Dispute-Status-pop.Payment-document"
                                          )
                                        )
                                      ),
                                    ]),
                                    _c("div", { staticClass: "img-upload" }, [
                                      _c(
                                        "div",
                                        [
                                          _c("input", {
                                            ref: "PaymentDocument",
                                            staticStyle: { display: "none" },
                                            attrs: {
                                              type: "file",
                                              accept: "image/*,.pdf",
                                            },
                                            on: {
                                              change: function (e) {
                                                return _vm.handleHiddenFileInputChange(
                                                  e,
                                                  "paymentDocument",
                                                  "image",
                                                  "paymentDocumentType",
                                                  "paymentDocumentError",
                                                  "Payment-document"
                                                )
                                              },
                                            },
                                          }),
                                          _vm.image &&
                                          (_vm.paymentDocumentType ===
                                            "image" ||
                                            _vm.paymentDocumentType === "pdf")
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "upload-privew",
                                                },
                                                [
                                                  _c("feather-icon", {
                                                    staticClass:
                                                      "cursor-pointer",
                                                    attrs: {
                                                      icon: "EyeIcon",
                                                      size: "20",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showImage(
                                                          true,
                                                          "image",
                                                          "paymentDocumentType"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c("feather-icon", {
                                                    staticClass:
                                                      "cursor-pointer",
                                                    attrs: {
                                                      icon: "UploadIcon",
                                                      size: "20",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.picDocument(
                                                          "PaymentDocument"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.image &&
                                          _vm.paymentDocumentType === "image"
                                            ? _c("b-img", {
                                                staticClass: "camera",
                                                attrs: {
                                                  src: _vm.image,
                                                  alt: "pic image",
                                                },
                                              })
                                            : _vm._e(),
                                          _vm.image &&
                                          _vm.paymentDocumentType === "pdf"
                                            ? _c("PDF", {
                                                staticClass:
                                                  "upload-img-pick pdf-icon-pick",
                                              })
                                            : _c("Upload", {
                                                staticClass: "upload-img-pick",
                                                class: _vm.image
                                                  ? "img-disable"
                                                  : "",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.picDocument(
                                                      "PaymentDocument"
                                                    )
                                                  },
                                                },
                                              }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("Errors", {
                                  attrs: { error: _vm.paymentDocumentError },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "pay-note" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("Dispute-Status-pop.Payment-Note-1")
                                  ) +
                                  " "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "mt-1 mb-2" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "bv-no-focus-ring col-form-label pt-0",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Dispute-Status-pop.Upload-proof"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-uplooad pay-upload p-none",
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Dispute-Status-pop.Payment-statement"
                                          )
                                        )
                                      ),
                                    ]),
                                    _c("div", { staticClass: "img-upload" }, [
                                      _c(
                                        "div",
                                        [
                                          _c("input", {
                                            ref: "PaymentStatement",
                                            staticStyle: { display: "none" },
                                            attrs: {
                                              type: "file",
                                              accept: ".pdf",
                                            },
                                            on: {
                                              change: function (e) {
                                                return _vm.handleHiddenFileInputChange(
                                                  e,
                                                  "paymentStatement",
                                                  "pdf",
                                                  "paymentStatementType",
                                                  "paymentStatementError",
                                                  "Payment-statement"
                                                )
                                              },
                                            },
                                          }),
                                          _vm.pdf &&
                                          _vm.paymentStatementType === "pdf"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "upload-privew pdf-icon",
                                                },
                                                [
                                                  _c("feather-icon", {
                                                    staticClass:
                                                      "cursor-pointer",
                                                    attrs: {
                                                      icon: "EyeIcon",
                                                      size: "20",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showImage(
                                                          true,
                                                          "pdf",
                                                          "paymentStatementType"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c("feather-icon", {
                                                    staticClass:
                                                      "cursor-pointer",
                                                    attrs: {
                                                      icon: "UploadIcon",
                                                      size: "20",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.picDocument(
                                                          "PaymentStatement"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.pdf
                                            ? _c("PDF", {
                                                staticClass:
                                                  "upload-img-pick pdf-icon-pick",
                                              })
                                            : _c("Upload", {
                                                staticClass: "upload-img-pick",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.picDocument(
                                                      "PaymentStatement"
                                                    )
                                                  },
                                                },
                                              }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("Errors", {
                                  attrs: { error: _vm.paymentStatementError },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "pay-note" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("Dispute-Status-pop.Payment-Note-2")
                                  ) +
                                  " "
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "mt-1 mb-2" },
                          [
                            _c(
                              "b-form-group",
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "bv-no-focus-ring col-form-label pt-0",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Dispute-Status-pop.Upload-proof"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-uplooad pay-upload p-none",
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Dispute-Status-pop.Payment-video"
                                          )
                                        )
                                      ),
                                    ]),
                                    _c("div", { staticClass: "img-upload" }, [
                                      _c(
                                        "div",
                                        [
                                          _c("input", {
                                            ref: "PaymentVideo",
                                            staticStyle: { display: "none" },
                                            attrs: {
                                              type: "file",
                                              accept: ".mkv,video/*",
                                            },
                                            on: {
                                              change: function (e) {
                                                return _vm.handleHiddenFileInputChange(
                                                  e,
                                                  "paymentVideo",
                                                  "video",
                                                  "paymentVideoType",
                                                  "paymentVideoError",
                                                  "Payment-video"
                                                )
                                              },
                                            },
                                          }),
                                          _vm.video &&
                                          _vm.paymentVideoType === "video"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "upload-privew video-icon",
                                                },
                                                [
                                                  _c("feather-icon", {
                                                    staticClass:
                                                      "cursor-pointer",
                                                    attrs: {
                                                      icon: "EyeIcon",
                                                      size: "20",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showImage(
                                                          true,
                                                          "video",
                                                          "paymentVideoType"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c("feather-icon", {
                                                    staticClass:
                                                      "cursor-pointer",
                                                    attrs: {
                                                      icon: "UploadIcon",
                                                      size: "20",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.picDocument(
                                                          "PaymentVideo"
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.video
                                            ? _c("VideosIcon", {
                                                staticClass:
                                                  "upload-img-pick pdf-icon-pick",
                                              })
                                            : _c("Upload", {
                                                staticClass: "upload-img-pick",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.picDocument(
                                                      "PaymentVideo"
                                                    )
                                                  },
                                                },
                                              }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("Errors", {
                                  attrs: { error: _vm.paymentVideoError },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "pay-note" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("Dispute-Status-pop.Payment-Note-3")
                                  ) +
                                  " "
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "pay-note text-danger mt-1 mb-1" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "Dispute-Status-pop.Payment-Note-4"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "mb-1 mt-1 text-center",
                                attrs: { type: "submit", variant: "primary" },
                              },
                              [_vm._v(_vm._s(_vm.$t("dispute.Dispute")))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("ImagePreview", {
        attrs: {
          showPop: _vm.showDocumentPreviewModal,
          onModalHidden: _vm.showImage,
          url: _vm.url,
          documentType: _vm.type,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/CancelOrder/DisputeRaised.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import assets_rashi_coin_upload_icon_svg from '@/assets/rashi-coin/upload_icon.svg';
import assets_rashi_coin_upload_svg from '@/assets/rashi-coin/upload.svg';
import vue_select from 'vue-select';
import layouts_components_Stepper_vue from '@/layouts/components/Stepper.vue';
import * as vuex from 'vuex';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import libs_api_api from '@/libs/api/api';
import * as veevalidate from 'vee-validate';
import validations from '@validations';
import layouts_components_ImagePreview_vue from '@/layouts/components/ImagePreview.vue';
import layouts_components_VideoPreview_vue from '@/layouts/components/VideoPreview.vue';
import assets_rashi_coin_pdf_icon_svg from '@/assets/rashi-coin/pdf-icon.svg';
import assets_rashi_coin_movie_videos_icon_svg from '@/assets/rashi-coin/movie-videos-icon.svg';
import utils_constants from '@/utils/constants';
import layouts_components_Errors_vue from '@/layouts/components/Errors.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















export default ({
  render,
  staticRenderFns,
  components: {
    BModal: bootstrapvue["BModal"],
    BButton: bootstrapvue["BButton"],
    BFormTextarea: bootstrapvue["BFormTextarea"],
    Reupload: assets_rashi_coin_upload_icon_svg,
    Upload: assets_rashi_coin_upload_svg,
    VideosIcon: assets_rashi_coin_movie_videos_icon_svg,
    vSelect: vue_select,
    Stepper: layouts_components_Stepper_vue,
    BAlert: bootstrapvue["BAlert"],
    BFormGroup: bootstrapvue["BFormGroup"],
    ValidationProvider: veevalidate["ValidationProvider"],
    ValidationObserver: veevalidate["ValidationObserver"],
    BForm: bootstrapvue["BForm"],
    BImg: bootstrapvue["BImg"],
    ImagePreview: layouts_components_ImagePreview_vue,
    PDF: assets_rashi_coin_pdf_icon_svg,
    VideoPreview: layouts_components_VideoPreview_vue,
    Errors: layouts_components_Errors_vue
  },
  computed: {
    ...vuex.mapState("user", ["refData"])
  },
  data() {
    return {
      modalVisible: this.showPop,
      message: "",
      reason: "",
      options: [],
      updateState: 0,
      required: validations["required"],
      paymentDocument: null,
      paymentVideo: null,
      paymentStatement: null,
      paymentDocumentType: null,
      paymentVideoType: null,
      paymentStatementType: null,
      image: null,
      pdf: null,
      video: null,
      paymentDocumentError: null,
      paymentVideoError: null,
      paymentStatementError: null,
      type: "",
      url: "",
      showDocumentPreviewModal: false,
      steps: [{
        title: this.$t("Dispute-Status-pop.Dispute-Raised")
      }, {
        title: this.$t("Dispute-Status-pop.Discuss-with-Counterparty")
      }, {
        title: this.$t("Dispute-Status-pop.Support-Review")
      }, {
        title: this.$t("Dispute-Status-pop.Dispute-Resolved")
      }],
      lang: this.$route.params.lang
    };
  },
  watch: {
    showPop(newValue) {
      this.modalVisible = newValue;
    },
    refData(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setDisputeReasonOptions();
      }
    },
    adOrderEntity(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setDisputeReasonOptions();
      }
    }
  },
  mounted() {
    this.setDisputeReasonOptions();
  },
  methods: {
    setDisputeReasonOptions() {
      if (this.adOrderEntity && this.adOrderEntity.orderType && this.refData) {
        if (this.adOrderEntity.orderType === "BUY") {
          this.options = this.refData.disputeReasons.buyerDisputeReason;
        } else if (this.adOrderEntity.orderType === "SELL") {
          this.options = this.refData.disputeReasons.selleDisputeReason;
        }
      }
    },
    showImage(flag, url, type) {
      this.showDocumentPreviewModal = flag;
      if (flag) {
        this.url = this[url];
        this.type = this[type];
      } else {
        this.url = "";
        this.type = "";
      }
    },
    picDocument(input) {
      if (this.$refs[input]) {
        this.$refs[input].click();
      }
    },
    checkAllValidDocument(document, error, field) {
      if (!this[document]) {
        this[error] = this.$t(`Dispute-Status-pop.isRequired`, {
          field
        });
        return false;
      } else {
        this[error] = null;
        return true;
      }
    },
    validationForm() {
      this.checkAllValidDocument("paymentDocument", "paymentDocumentError", this.$t("Dispute-Status-pop.Payment-document"));
      this.checkAllValidDocument("paymentVideo", "paymentVideoError", this.$t("Dispute-Status-pop.Payment-video"));
      this.checkAllValidDocument("paymentStatement", "paymentStatementError", this.$t("Dispute-Status-pop.Payment-statement"));
      this.$refs.disputeForm.validate().then(success => {
        if (success && !this.paymentDocumentError && !this.paymentVideoError && !this.paymentStatementError) {
          this.addDispute();
        }
      });
    },
    async addDispute() {
      try {
        if (this.$route.params.id) {
          this.message = this.message.trim();
          const formData = new FormData();
          this.$route.params.id && formData.append("adOrderId", this.$route.params.id);
          this.reason && formData.append("reason", this.reason);
          this.message && formData.append("disputeDesc", this.message);
          this.paymentDocument && formData.append("paymentTxDocUrl", this.paymentDocument);
          this.paymentVideo && formData.append("paymentTxAccountVideoUrl", this.paymentVideo);
          this.paymentStatement && formData.append("paymentTxBankStatementDocUrl", this.paymentStatement);
          const res = await new libs_api_api().api({
            method: "post",
            url: "p2p/dispute/save"
          }, formData, {
            isLoading: true
          });
          if (res && res.result && res.result.requestStatus && res.result.requestStatus === "SUCCESS") {
            this.$router.push({
              name: "disputeStatus",
              params: {
                lang: this.lang || undefined,
                id: this.$route.params.id
              }
            });
          } else if (res && res.error && res.error.message) {
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: res.error.message,
                icon: "EditIcon",
                variant: "danger"
              }
            });
          }
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    },
    handleHiddenFileInputChange(event, document, documentImage, documentType, error, field) {
      const file = event.target.files[0];
      if (file) {
        this[document] = "";
        this[documentImage] = "";
        const maxFileSize = utils_constants["sizeLimit"] * 1024 * 1024;
        const maxVideoSize = utils_constants["videoSizeLimit"] * 1024 * 1024;
        if ((file.type.includes("image") || file.type === "application/pdf") && file.size >= maxFileSize) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: this.$t("Errors.UnsupportedFileSize", {
                limit: utils_constants["sizeLimit"]
              }),
              icon: "EditIcon",
              variant: "danger"
            }
          });
          return;
        } else if (file.type.includes("video") && file.size >= maxVideoSize) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: this.$t("Errors.UnsupportedFileSize", {
                limit: utils_constants["videoSizeLimit"]
              }),
              icon: "EditIcon",
              variant: "danger"
            }
          });
          return;
        }
        const reader = new FileReader();
        reader.onload = e => {
          if (file.type.includes("image") && document === "paymentDocument") {
            this[documentType] = "image";
          } else if (file.type.includes("video") && document === "paymentVideo") {
            this[documentType] = "video";
          } else if (file.type === "application/pdf" && ["paymentDocument", "paymentStatement"].includes(document)) {
            this[documentType] = "pdf";
          } else {
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: this.$t("Errors.UnsupportedFileType"),
                icon: "EditIcon",
                variant: "danger"
              }
            });
            return;
          }
          this[document] = file;
          this[documentImage] = e.target.result;
          this.checkAllValidDocument(document, error, this.$t(`Dispute-Status-pop.${field}`));
        };
        reader.readAsDataURL(file);
        this.showVideo = false;
      }
    }
  },
  props: {
    showPop: {
      type: Boolean,
      isRequired: false,
      default: false
    },
    onModalHidden: {
      type: Function,
      isRequired: true,
      default: () => {}
    },
    adOrderEntity: {
      type: Object,
      isRequired: true,
      default: () => {}
    }
  }
});

//# sourceURL=webpack:///./src/layouts/components/CancelOrder/DisputeRaised.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style>
.v-select {
  position: relative;
  font-family: inherit;
}
.v-select,
.v-select * {
  box-sizing: border-box;
}

/* KeyFrames */
@-webkit-keyframes vSelectSpinner-ltr {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
}
@-webkit-keyframes vSelectSpinner-rtl {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(-360deg);
}
}
@keyframes vSelectSpinner-ltr {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
}
@keyframes vSelectSpinner-rtl {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(-360deg);
}
}
/* Dropdown Default Transition */
.vs__fade-enter-active,
.vs__fade-leave-active {
  pointer-events: none;
  transition: opacity 0.15s cubic-bezier(1, 0.5, 0.8, 1);
}
.vs__fade-enter,
.vs__fade-leave-to {
  opacity: 0;
}

/** Component States */
/*
 * Disabled
 *
 * When the component is disabled, all interaction
 * should be prevented. Here we modify the bg color,
 * and change the cursor displayed on the interactive
 * components.
 */
[dir] .vs--disabled .vs__dropdown-toggle, [dir] .vs--disabled .vs__clear, [dir] .vs--disabled .vs__search, [dir] .vs--disabled .vs__selected, [dir] .vs--disabled .vs__open-indicator {
  cursor: not-allowed;
  background-color: #f8f8f8;
}

/*
 *  RTL - Right to Left Support
 *
 *  Because we're using a flexbox layout, the `dir="rtl"`
 *  HTML attribute does most of the work for us by
 *  rearranging the child elements visually.
 */
.v-select[dir=rtl] .vs__actions {
  padding: 0 3px 0 6px;
}
.v-select[dir=rtl] .vs__clear {
  margin-left: 6px;
  margin-right: 0;
}
.v-select[dir=rtl] .vs__deselect {
  margin-left: 0;
  margin-right: 2px;
}
.v-select[dir=rtl] .vs__dropdown-menu {
  text-align: right;
}

/**
    Dropdown Toggle

    The dropdown toggle is the primary wrapper of the component. It
    has two direct descendants: .vs__selected-options, and .vs__actions.

    .vs__selected-options holds the .vs__selected's as well as the
    main search input.

    .vs__actions holds the clear button and dropdown toggle.
 */
.vs__dropdown-toggle {
  appearance: none;
  display: flex;
  white-space: normal;
}
[dir] .vs__dropdown-toggle {
  padding: 0 0 4px 0;
  background: none;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
}
.vs__selected-options {
  display: flex;
  flex-basis: 100%;
  flex-grow: 1;
  flex-wrap: wrap;
  position: relative;
}
[dir] .vs__selected-options {
  padding: 0 2px;
}
.vs__actions {
  display: flex;
  align-items: center;
}
[dir=ltr] .vs__actions {
  padding: 4px 6px 0 3px;
}
[dir=rtl] .vs__actions {
  padding: 4px 3px 0 6px;
}

/* Dropdown Toggle States */
[dir] .vs--searchable .vs__dropdown-toggle {
  cursor: text;
}
[dir] .vs--unsearchable .vs__dropdown-toggle {
  cursor: pointer;
}
[dir] .vs--open .vs__dropdown-toggle {
  border-bottom-color: transparent;
}
[dir=ltr] .vs--open .vs__dropdown-toggle {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir=rtl] .vs--open .vs__dropdown-toggle {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.vs__open-indicator {
  fill: rgba(60, 60, 60, 0.5);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
}
[dir] .vs__open-indicator {
  transform: scale(1);
  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}
[dir=ltr] .vs--open .vs__open-indicator {
  transform: rotate(180deg) scale(1);
}
[dir=rtl] .vs--open .vs__open-indicator {
  transform: rotate(-180deg) scale(1);
}
.vs--loading .vs__open-indicator {
  opacity: 0;
}

/* Clear Button */
.vs__clear {
  fill: rgba(60, 60, 60, 0.5);
}
[dir] .vs__clear {
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
}
[dir=ltr] .vs__clear {
  margin-right: 8px;
}
[dir=rtl] .vs__clear {
  margin-left: 8px;
}

/* Dropdown Menu */
.vs__dropdown-menu {
  display: block;
  box-sizing: border-box;
  position: absolute;
  top: calc(100% - 1px);
  z-index: 1000;
  width: 100%;
  max-height: 350px;
  min-width: 160px;
  overflow-y: auto;
  list-style: none;
}
[dir] .vs__dropdown-menu {
  padding: 5px 0;
  margin: 0;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  border: 1px solid #d8d6de;
  border-top-style: none;
  border-radius: 0 0 0.357rem 0.357rem;
  background: #fff;
}
[dir=ltr] .vs__dropdown-menu {
  left: 0;
  text-align: left;
}
[dir=rtl] .vs__dropdown-menu {
  right: 0;
  text-align: right;
}
[dir] .vs__no-options {
  text-align: center;
}

/* List Items */
.vs__dropdown-option {
  line-height: 1.42857143;
  /* Normalize line height */
  display: block;
  color: #333;
  /* Overrides most CSS frameworks */
  white-space: nowrap;
}
[dir] .vs__dropdown-option {
  padding: 3px 20px;
  clear: both;
}
[dir] .vs__dropdown-option:hover {
  cursor: pointer;
}
.vs__dropdown-option--highlight {
  color: #8dc540 !important;
}
[dir] .vs__dropdown-option--highlight {
  background: rgba(141, 197, 64, 0.12);
}
.vs__dropdown-option--disabled {
  color: rgba(60, 60, 60, 0.5);
}
[dir] .vs__dropdown-option--disabled {
  background: inherit;
}
[dir] .vs__dropdown-option--disabled:hover {
  cursor: inherit;
}

/* Selected Tags */
.vs__selected {
  display: flex;
  align-items: center;
  color: #333;
  line-height: 1.8;
  z-index: 0;
}
[dir] .vs__selected {
  background-color: #8dc540;
  border: 0 solid rgba(60, 60, 60, 0.26);
  border-radius: 0.357rem;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
}
.vs__deselect {
  display: inline-flex;
  appearance: none;
  fill: rgba(60, 60, 60, 0.5);
}
[dir] .vs__deselect {
  padding: 0;
  border: 0;
  cursor: pointer;
  background: none;
  text-shadow: 0 1px 0 #fff;
}
[dir=ltr] .vs__deselect {
  margin-left: 4px;
}
[dir=rtl] .vs__deselect {
  margin-right: 4px;
}

/* States */
[dir] .vs--single .vs__selected {
  background-color: transparent;
  border-color: transparent;
}
.vs--single.vs--open .vs__selected {
  position: absolute;
  opacity: 0.4;
}
.vs--single.vs--searching .vs__selected {
  display: none;
}

/* Search Input */
/**
 * Super weird bug... If this declaration is grouped
 * below, the cancel button will still appear in chrome.
 * If it's up here on it's own, it'll hide it.
 */
.vs__search::-webkit-search-cancel-button {
  display: none;
}
.vs__search::-webkit-search-decoration,
.vs__search::-webkit-search-results-button,
.vs__search::-webkit-search-results-decoration,
.vs__search::-ms-clear {
  display: none;
}
.vs__search,
.vs__search:focus {
  appearance: none;
  line-height: 1.8;
  font-size: 1em;
  outline: none;
  width: 0;
  max-width: 100%;
  flex-grow: 1;
  z-index: 1;
}
[dir] .vs__search, [dir] .vs__search:focus {
  border: 1px solid transparent;
  margin: 4px 0 0 0;
  padding: 0 7px;
  background: none;
  box-shadow: none;
}
[dir=ltr] .vs__search, [dir=ltr] .vs__search:focus {
  border-left: none;
}
[dir=rtl] .vs__search, [dir=rtl] .vs__search:focus {
  border-right: none;
}
.vs__search::placeholder {
  color: #6e6b7b;
}

/**
    States
 */
.vs--unsearchable .vs__search {
  opacity: 1;
}
[dir] .vs--unsearchable:not(.vs--disabled) .vs__search:hover {
  cursor: pointer;
}
.vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search {
  opacity: 0.2;
}

/* Loading Spinner */
.vs__spinner {
  align-self: center;
  opacity: 0;
  font-size: 5px;
  text-indent: -9999em;
  overflow: hidden;
  transition: opacity 0.1s;
}
[dir] .vs__spinner {
  border-top: 0.9em solid rgba(100, 100, 100, 0.1);
  border-bottom: 0.9em solid rgba(100, 100, 100, 0.1);
  transform: translateZ(0);
}
[dir=ltr] .vs__spinner {
  border-right: 0.9em solid rgba(100, 100, 100, 0.1);
  border-left: 0.9em solid rgba(60, 60, 60, 0.45);
  animation:  vSelectSpinner-ltr 1.1s infinite linear;
}
[dir=rtl] .vs__spinner {
  border-left: 0.9em solid rgba(100, 100, 100, 0.1);
  border-right: 0.9em solid rgba(60, 60, 60, 0.45);
  animation:  vSelectSpinner-rtl 1.1s infinite linear;
}
.vs__spinner,
.vs__spinner:after {
  width: 5em;
  height: 5em;
}
[dir] .vs__spinner, [dir] .vs__spinner:after {
  border-radius: 50%;
}

/* Loading Spinner States */
.vs--loading .vs__spinner {
  opacity: 1;
}
.vs__open-indicator {
  fill: none;
}
[dir] .vs__open-indicator {
  margin-top: 0.15rem;
}
.vs__dropdown-toggle {
  transition: all 0.25s ease-in-out;
}
[dir] .vs__dropdown-toggle {
  padding: 0.59px 0 4px 0;
}
[dir=ltr] .vs--single .vs__dropdown-toggle {
  padding-left: 6px;
}
[dir=rtl] .vs--single .vs__dropdown-toggle {
  padding-right: 6px;
}
.vs__dropdown-option--disabled {
  opacity: 0.5;
}
[dir] .vs__dropdown-option--disabled.vs__dropdown-option--selected {
  background: #8dc540 !important;
}
.vs__dropdown-option {
  color: #6e6b7b;
}
[dir] .vs__dropdown-option, [dir] .vs__no-options {
  padding: 7px 20px;
}
.vs__dropdown-option--selected {
  background-color: #8dc540;
  color: #fff;
  position: relative;
}
.vs__dropdown-option--selected::after {
  content: "";
  height: 1.1rem;
  width: 1.1rem;
  display: inline-block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-check'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 1.1rem;
}
[dir=rtl] .vs__dropdown-option--selected::after {
  left: 20px;
  right: unset;
}
.vs__dropdown-option--selected.vs__dropdown-option--highlight {
  color: #fff !important;
  background-color: #8dc540 !important;
}
.vs__clear svg {
  color: #6e6b7b;
}
.vs__selected {
  color: #fff;
}
.v-select.vs--single .vs__selected {
  color: #6e6b7b;
  transition: transform 0.2s ease;
}
[dir] .v-select.vs--single .vs__selected {
  margin-top: 5px;
}
[dir=ltr] .v-select.vs--single .vs__selected input {
  padding-left: 0;
}
[dir=rtl] .v-select.vs--single .vs__selected input {
  padding-right: 0;
}
[dir=ltr] .vs--single.vs--open .vs__selected {
  transform: translateX(5px);
}
[dir=rtl] .vs--single.vs--open .vs__selected {
  transform: translateX(-5px);
}
.vs__selected .vs__deselect {
  color: inherit;
}
.v-select:not(.vs--single) .vs__selected {
  font-size: 0.9rem;
}
[dir] .v-select:not(.vs--single) .vs__selected {
  border-radius: 3px;
  padding: 0 0.6em;
}
[dir=ltr] .v-select:not(.vs--single) .vs__selected {
  margin: 5px 2px 2px 5px;
}
[dir=rtl] .v-select:not(.vs--single) .vs__selected {
  margin: 5px 5px 2px 2px;
}
.v-select:not(.vs--single) .vs__deselect svg {
  vertical-align: text-top;
}
[dir] .v-select:not(.vs--single) .vs__deselect svg {
  transform: scale(0.8);
}
.vs__dropdown-menu {
  top: calc(100% + 1rem);
}
[dir] .vs__dropdown-menu {
  border: none;
  border-radius: 6px;
  padding: 0;
}
[dir] .vs--open .vs__dropdown-toggle {
  border-color: #8dc540;
  border-bottom-color: #8dc540;
  box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
}
[dir=ltr] .vs--open .vs__dropdown-toggle {
  border-bottom-left-radius: 0.357rem;
  border-bottom-right-radius: 0.357rem;
}
[dir=rtl] .vs--open .vs__dropdown-toggle {
  border-bottom-right-radius: 0.357rem;
  border-bottom-left-radius: 0.357rem;
}
.select-size-lg .vs__selected {
  font-size: 1rem !important;
}
[dir] .select-size-lg.vs--single.vs--open .vs__selected {
  margin-top: 6px;
}
.select-size-lg .vs__dropdown-toggle,
.select-size-lg .vs__selected {
  font-size: 1.25rem;
}
[dir] .select-size-lg .vs__dropdown-toggle {
  padding: 5px;
}
[dir] .select-size-lg .vs__dropdown-toggle input {
  margin-top: 0;
}
.select-size-lg .vs__deselect svg {
  vertical-align: middle !important;
}
[dir] .select-size-lg .vs__deselect svg {
  transform: scale(1) !important;
}
[dir] .select-size-sm .vs__dropdown-toggle {
  padding-bottom: 0;
  padding: 1px;
}
[dir] .select-size-sm.vs--single .vs__dropdown-toggle {
  padding: 2px;
}
.select-size-sm .vs__dropdown-toggle,
.select-size-sm .vs__selected {
  font-size: 0.9rem;
}
[dir] .select-size-sm .vs__actions {
  padding-top: 2px;
  padding-bottom: 2px;
}
.select-size-sm .vs__deselect svg {
  vertical-align: middle !important;
}
[dir] .select-size-sm .vs__search {
  margin-top: 0;
}
.select-size-sm.v-select .vs__selected {
  font-size: 0.75rem;
}
[dir] .select-size-sm.v-select .vs__selected {
  padding: 0 0.3rem;
}
[dir] .select-size-sm.v-select:not(.vs--single) .vs__selected {
  margin: 4px 5px;
}
[dir] .select-size-sm.v-select.vs--single .vs__selected {
  margin-top: 1px;
}
[dir] .select-size-sm.vs--single.vs--open .vs__selected {
  margin-top: 4px;
}
.dark-layout .vs__dropdown-toggle {
  color: #b4b7bd;
}
[dir] .dark-layout .vs__dropdown-toggle {
  background: #283046;
  border-color: #404656;
}
.dark-layout .vs__selected-options input {
  color: #b4b7bd;
}
.dark-layout .vs__selected-options input::placeholder {
  color: #676d7d;
}
.dark-layout .vs__actions svg {
  fill: #404656;
}
[dir] .dark-layout .vs__dropdown-menu {
  background: #283046;
}
.dark-layout .vs__dropdown-menu li {
  color: #b4b7bd;
}
.dark-layout .v-select:not(.vs--single) .vs__selected {
  color: #8dc540;
}
[dir] .dark-layout .v-select:not(.vs--single) .vs__selected {
  background-color: rgba(141, 197, 64, 0.12);
}
.dark-layout .v-select.vs--single .vs__selected {
  color: #b4b7bd !important;
}
.dark-layout .vs--disabled .vs__dropdown-toggle,
.dark-layout .vs--disabled .vs__clear,
.dark-layout .vs--disabled .vs__search,
.dark-layout .vs--disabled .vs__selected,
.dark-layout .vs--disabled .vs__open-indicator {
  opacity: 0.5;
}
[dir] .dark-layout .vs--disabled .vs__dropdown-toggle, [dir] .dark-layout .vs--disabled .vs__clear, [dir] .dark-layout .vs--disabled .vs__search, [dir] .dark-layout .vs--disabled .vs__selected, [dir] .dark-layout .vs--disabled .vs__open-indicator {
  background-color: #283046;
}
.pay-note {
  font-size: 12px;
  color: #000;
}
</style>
